import React, { useContext, useEffect, useState } from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import { useTheme } from '../../../contexts/ThemeContext';
import { getCompanyInfo } from '../../../services/companyService';
import TechLoader from '../../common/TechLoader';

const Layout = ({ children }) => {
  const { theme, toggleTheme } = useTheme();
  const [companyInfo, setCompanyInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCompanyInfo = async () => {
      try {
        setLoading(true);
        const data = await getCompanyInfo();
        setCompanyInfo(data);
        setError(null);
      } catch (err) {
        console.error('Failed to fetch company info:', err);
        setError('Failed to load company information');
      } finally {
        setLoading(false);
      }
    };

    fetchCompanyInfo();
  }, []);

  useEffect(() => {
    // Update body class for consistent theming
    document.body.className = theme === 'dark' ? 'bg-gray-900' : 'bg-gray-50';
  }, [theme]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <TechLoader size="large" text="Loading..." />
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center text-red-500">
        {error}
      </div>
    );
  }

  return (
    <div className={`min-h-screen flex flex-col transition-colors duration-200 ${
      theme === 'dark' 
        ? 'bg-gray-900 text-white' 
        : 'bg-gray-50 text-gray-900'
    }`}>
      <Navbar theme={theme} companyInfo={companyInfo} />
      <main className="flex-grow">{children}</main>
      <Footer theme={theme} companyInfo={companyInfo} />
    </div>
  );
};

export default Layout;
